import { render, staticRenderFns } from "./OrderCell.vue?vue&type=template&id=c404a0a6&scoped=true"
import script from "./OrderCell.vue?vue&type=script&lang=js"
export * from "./OrderCell.vue?vue&type=script&lang=js"
import style0 from "./OrderCell.vue?vue&type=style&index=0&id=c404a0a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c404a0a6",
  null
  
)

export default component.exports